import { t } from "../../utils/i18n";
import { AppState, SchemadrawProps } from "../../utils/types";

const LibraryMenuBrowseButton = ({
  theme,
  id,
  libraryReturnUrl,
}: {
  libraryReturnUrl: SchemadrawProps["libraryReturnUrl"];
  theme: AppState["theme"];
  id: string;
}) => {
  const referrer =
    libraryReturnUrl || window.location.origin + window.location.pathname;
  return (
    <a
      className="library-menu-browse-button"
      href={`https://www.procviz.com/library`}
      target="_procviz_libraries"
    >
      {t("labels.libraries")}
    </a>
  );
};

export default LibraryMenuBrowseButton;
